import phoneNumberInputHelper from "../../../../../../common/components/form/input/phone-number/phone-number-input.helper";
import { FormValidationDefinition } from "../../../../../../common/components/form/use-form";
import driverAddUserDataFormValidationService from "./driver-add-user-data-form-validation.service";
import RailyDriverAddUserFormData from "./types/raily-driver-add-user-form-data";

const getDefaultUserFormData = (): RailyDriverAddUserFormData => {
  return {
    firstName: "",
    lastName: "",
    mobile: phoneNumberInputHelper.getEmptyValue(),
    alternativeMobile: phoneNumberInputHelper.getEmptyValue(),
    birthDate: null,
    birthPlace: "",
    personalIdNumber: "",
    citizenship: null,
    languages: [],
    yearsOfExperience: null,
    addresses: [],
  };
};

const getUserValidationDefinition =
  (): FormValidationDefinition<RailyDriverAddUserFormData> => {
    return {
      addresses: (values) =>
        driverAddUserDataFormValidationService.validateAddresses(
          values.addresses
        ),
      alternativeMobile: (values) =>
        driverAddUserDataFormValidationService.validateAlternativeMobile(
          values.alternativeMobile
        ),
      birthDate: (values) =>
        driverAddUserDataFormValidationService.validateBirthDate(
          values.birthDate
        ),
      birthPlace: (values) =>
        driverAddUserDataFormValidationService.validateBirthPlace(
          values.birthPlace
        ),
      citizenship: (values) =>
        driverAddUserDataFormValidationService.validateCitizenship(
          values.citizenship
        ),
      firstName: (values) =>
        driverAddUserDataFormValidationService.validateFirstName(
          values.firstName
        ),
      languages: (values) =>
        driverAddUserDataFormValidationService.validateLanguages(
          values.languages
        ),
      lastName: (values) =>
        driverAddUserDataFormValidationService.validateLastName(
          values.lastName
        ),
      mobile: (values) =>
        driverAddUserDataFormValidationService.validateMobile(values.mobile),
      personalIdNumber: (values) =>
        driverAddUserDataFormValidationService.validatePersonalIdNumber(
          values.personalIdNumber
        ),
      yearsOfExperience: (values) =>
        driverAddUserDataFormValidationService.validateYearsOfExperience(
          values.yearsOfExperience
        ),
    };
  };

const railyDriverAddUserFormHelper = {
  getDefaultUserFormData,
  getUserValidationDefinition,
};

export default railyDriverAddUserFormHelper;
